import { TermPinServant } from '../../../components/term_pin/servants/term_pin_servant';
import {
  HILForm,
  IRegistrationSection,
  ISection,
  RegAttributesForSections
} from '../../../interfaces/scheduler_interfaces';
import { ClearTransientAccessCredCommand } from '../../../prevent_transient_access/commands/clear_transient_access_cred_command';
import { TransientAccessCredEventNames } from '../../../prevent_transient_access/constants/transient_access_cred_constants';
import { PreventTransientAccessQuery } from '../../../prevent_transient_access/queries/prevent_transient_access_query';
import { SubmitRegAttrFormAndGetOutputCommand } from '../../../registration_attributes/commands/submit_reg_attr_form_and_get_output_command';
import { CourseSchedulerConstant } from '../../course_scheduler/constants/course_scheduler_constants';
import { RegisterSectionsQuery } from '../../course_scheduler/queries/register_sections_query';
import { ScheduledSectionsQuery } from '../../course_scheduler/queries/scheduled_sections_query';
import { ScheduledSectionStatusServant } from '../../course_scheduler/servants/scheduled_section_status_servant';
import { TermCourseServant } from '../../term_courses/servants/term_course_servant';
import { ToggleRegistrationFriendlyReminderPromptCommand } from '../commands/toggle_registration_friendly_reminder_prompt_command';
import { updateRegistrationFlagCommand } from '../commands/update_registration_flag_command';
import { UpdateRegistrationFriendlyReminderFlagsCommand } from '../commands/update_registration_friendly_reminder_flags_command';
import { RegistrationSelectedSectionsQuery } from '../queries/registration_selected_sections_query';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { ICommand } from 'core-ts-types';
import { GetTermPinCommand } from '../../../components/term_pin/commands/get_term_pin_command';
import { SaveTermPinCommand } from '../../../components/term_pin/commands/save_term_pin_command';
import { UpdateRegistrationRequestPendingCommand } from '../commands/update_registration_request_pending_command';
import { ScheduledSectionServant } from '../../course_scheduler/servants/scheduled_section_servant';
import { RegisterScheduledSectionsCommand } from '../../course_scheduler/commands/register_scheduled_sections_command';
import { StoreRegistrationAttributeValuesCommand } from '../../../registration_attributes/commands/store_registration_attribute_values_command';
import { WaitForRegistraionAttributesToRenderCommand } from '../../../registration_attributes/commands/wait_for_registration_attributes_to_render_command';
import { ShowRegisterButtonAfterPrecheckPassCommand } from '../commands/show_register_button_after_precheck_pass_command';
import { SchedulerNotificationServant } from '../../course_scheduler/servants/scheduler_notification_servant';

export class RegistrationFacade {
  constructor(
    private registrationRTRSvc: any,
    private ngRegisterSectionsQuery: RegisterSectionsQuery,
    private ngRegistrationSelectedSectionsQuery: RegistrationSelectedSectionsQuery,
    private updateRegistrationFlagCommand: updateRegistrationFlagCommand,
    private clearTransientAccessCredCommand: ClearTransientAccessCredCommand,
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant,
    private $window: any,
    private updateRegistrationFriendlyReminderFlagsCommand: UpdateRegistrationFriendlyReminderFlagsCommand,
    private ngComponentCommunicatorService: CommunicatorService,
    private submitRegAttrFormAndGetOutputCommand: SubmitRegAttrFormAndGetOutputCommand,
    private ngScheduledSectionsQuery: ScheduledSectionsQuery,
    private toggleRegistrationFriendlyReminderPromptCommand: ToggleRegistrationFriendlyReminderPromptCommand,
    private ngPreventTransientAccessQuery: PreventTransientAccessQuery,
    private ngTermPinServant: TermPinServant,
    private getTermPinCommand: GetTermPinCommand,
    private saveTermPinCommand: SaveTermPinCommand,
    private $stateParams: ng.ui.IStateParamsService,
    private updateRegistrationRequestPendingCommand: UpdateRegistrationRequestPendingCommand,
    private ngScheduledSectionServant: ScheduledSectionServant,
    private registerScheduledSectionsCommand: RegisterScheduledSectionsCommand,
    private storeRegistrationAttributeValuesCommand: StoreRegistrationAttributeValuesCommand,
    private selectAllRegistrationSectionsCommand: ICommand,
    private waitForRegistraionAttributesToRenderCommand: WaitForRegistraionAttributesToRenderCommand,
    private showRegisterButtonAfterPrecheckPassCommand: ShowRegisterButtonAfterPrecheckPassCommand,
    private $timeout: ng.ITimeoutService,
    private ngSchedulerNotificationServant: SchedulerNotificationServant
  ) {
    this.registrationPrecheckUpdated = this.registrationPrecheckUpdated.bind(this);
    this.saveTermPinAndContinue = this.saveTermPinAndContinue.bind(this);
  }

  beginRegistration() {
    this.reCalculateFlags().then(() => {
      if (!this.ngRegistrationSelectedSectionsQuery.result.disableRegistration) {
        this.clearTransientAccessCredCommand().then(() => this.registrationChecks());
      } else {
        this.ngSchedulerNotificationServant.showErrorNotification(
          'No Sections to Register',
          'Please select a section to register.'
        );
      }
    });
  }

  reCalculateFlags() {
    return this.updateRegistrationFlagCommand();
  }

  registrationChecks() {
    return this.shouldOpenFriendlyReminder().then((shouldOpenPrompt) => {
      const selectedSectionIds = this.getSelectedSectionIds();
      const regBind = this.registrationChecks.bind(this);
      this.ngComponentCommunicatorService.release(TransientAccessCredEventNames.NEW_CRED_SAVED, regBind);
      return this.submitAndGetRegAttributesForm(selectedSectionIds).then((regAttributeApiParam) => {
        if (shouldOpenPrompt) {
          return this.openFriendlyReminderPrompt();
        }
        if (this.ngPreventTransientAccessQuery.result.redirectToAuthWorkflow) {
          this.ngComponentCommunicatorService.publish(TransientAccessCredEventNames.OPEN_CRED_DIALOG);
          return this.ngComponentCommunicatorService.subscribe(TransientAccessCredEventNames.NEW_CRED_SAVED, regBind);
        }
        return this.registerSections(regAttributeApiParam as RegAttributesForSections);
      });
    });
  }

  openFriendlyReminderPrompt(): void {
    const regBind = this.registrationChecks.bind(this);
    const closePromptBind = this.closeFriendlyReminderPrompt.bind(this);
    this.toggleRegistrationFriendlyReminderPromptCommand(true, regBind, closePromptBind);
  }

  closeFriendlyReminderPrompt() {
    const regBind = this.registrationChecks.bind(this);
    const closePromptBind = this.closeFriendlyReminderPrompt.bind(this);
    this.toggleRegistrationFriendlyReminderPromptCommand(false, regBind, closePromptBind);
  }

  registrationPrecheckUpdated() {
    this.showRegisterButtonAfterPrecheckPassCommand();
  }

  private getUnselectedSections(): any {
    return _4.compact(
      _4.map(this.getUnselectedScheduledNonWaitlistedSections(), (unselectedSection: IRegistrationSection) => {
        const section = _4.find(this.ngScheduledSectionsQuery.result.list, (sec) => sec.id === unselectedSection.id);
        const isMultiSection = TermCourseServant.isMultiSectionCourse(section._course);
        const sectionType = isMultiSection ? ` - ${_4.truncate(section._section_type.name, { length: 18 })}` : '';
        return _4.merge(section, {
          id: unselectedSection.id,
          cd: section.cd,
          title: `${section._course.cd} ${section._course.title} ${sectionType}`
        });
      })
    );
  }

  private submitAndGetRegAttributesForm(sectionIds: Array<ISection['id']> = []) {
    this.ngComponentCommunicatorService.publish('SUBMIT_SCHEDULED_SECTIONS_FORM');
    const formElement = document.querySelector(`#${CourseSchedulerConstant.scheduledSectionFormId}`) as HILForm;
    return this.submitRegAttrFormAndGetOutputCommand(
      formElement,
      CourseSchedulerConstant.scheduledSectionFormId,
      sectionIds
    );
  }

  private shouldOpenFriendlyReminder() {
    return this.friendlyReminderRecalculateFlags().then(() => {
      if (this.ngRegistrationSelectedSectionsQuery.result.showRegistrationPrompt) {
        return false;
      }
      return (
        this.ngRegistrationSelectedSectionsQuery.result.isAnyScheduledSectionUnselected ||
        this.ngRegistrationSelectedSectionsQuery.result.hasAnyScheduledSectionMissingRequirements ||
        this.ngRegistrationSelectedSectionsQuery.result.hasAnyOptionalSectionNotScheduled
      );
    });
  }

  private friendlyReminderRecalculateFlags() {
    return this.updateRegistrationFriendlyReminderFlagsCommand();
  }

  getUnselectedScheduledNonWaitlistedSections() {
    return _4.filter(
      this.ngRegisterSectionsQuery.result.unselectedSections,
      (section: ISection) =>
        !this.ngScheduledSectionStatusServant.isStatusWaitlisted(section) && section._isEligibleForRegistration
    );
  }

  private getSelectedSectionIds() {
    return this.ngRegisterSectionsQuery.result.selectedSections.map((section) => section['id']);
  }

  private registerSections(regAttributeApiParams: Record<string, any>): void {
    this.closeFriendlyReminderPrompt();

    // open TermPIN model only if feature is enabled and if there is no TermPIN
    if (this.ngTermPinServant.isTermPinFeatureEnabled()) {
      this.getTermPinCommand(this.$stateParams.termId).then(() => {
        // If user alreday has a term PIN, just complete the registration
        if (this.ngTermPinServant.hasTermPin()) {
          this.completeRegistration(regAttributeApiParams);
        } else {
          this.ngComponentCommunicatorService.publish('OPEN_TERM_PIN_MODAL_BEFORE_REGISTRATION');
        }
      });
    }
    // Complete registration if TermPIN feature is off
    else {
      this.completeRegistration(regAttributeApiParams);
    }
  }

  private completeRegistration(regAttributeApiParams: Record<string, any> = {}) {
    this.updateRegistrationRequestPendingCommand(true);
    const autoWaitlistSectionIds = this.ngScheduledSectionServant.getAutoWaitlistSections(
      this.ngRegisterSectionsQuery.result.selectedSections
    );
    const selectedSectionIds = this.getSelectedSectionIds();

    return this.triggerSectionRegistration(selectedSectionIds, autoWaitlistSectionIds, regAttributeApiParams).then(() =>
      this.closeFriendlyReminderPrompt()
    );
  }

  private triggerSectionRegistration(
    sectionIds: Array<ISection['id']>,
    autoWaitlistSectionIds: Array<ISection['id']>,
    regAttributeApiParams: Record<string, any> = {}
  ) {
    this.updateRegistrationRequestPendingCommand(true);
    return this.registerScheduledSectionsCommand(
      this.$stateParams.termId,
      sectionIds,
      autoWaitlistSectionIds,
      {},
      regAttributeApiParams,
      this.ngPreventTransientAccessQuery.result.output
    ).finally(() => this.updateRegistrationRequestPendingCommand(false));
  }

  registerSelectedSections() {
    const selectedSectionIds = this.getSelectedSectionIds();
    if (this.ngPreventTransientAccessQuery.result.redirectToAuthWorkflow) {
      return this.submitAndGetRegAttributesForm(selectedSectionIds).then(() =>
        this.ngComponentCommunicatorService.publish(TransientAccessCredEventNames.TOGGLE_CRED_STEPS)
      );
    }
    return this.submitAndGetRegAttributesForm(selectedSectionIds).then((regAttributeApiParam) =>
      this.registerSections(regAttributeApiParam as RegAttributesForSections)
    );
  }

  registerAllSections() {
    if (this.ngPreventTransientAccessQuery.result.redirectToAuthWorkflow) {
      return this.prepareForRegisterAllSections()
        .catch((e) => {
          this.closeFriendlyReminderPrompt();
          /*
            This issue is happening because of the problem with the design of the work flow.
            Closing the prompt would set the focus back to it's trigger (Register button).
            But before that, as part of the submit process we had ran the validation process.
            That will set the focus to first invalid dropdown.
            Taking out the focus from the invalid dropdown and setting it to Register button would
            clear the validation error shown next to the dropdown.
            Re-running the submit process to run the validation and setting the focus back
            to the invalid first dropdown
          */
          this.$timeout(() => {
            const allSectionIds = this.getEligibleScheduledSectionIds();
            this.submitAndGetRegAttributesForm(allSectionIds);
          });
        })
        .then(() => this.ngComponentCommunicatorService.publish(TransientAccessCredEventNames.TOGGLE_CRED_STEPS));
    }
    this.closeFriendlyReminderPrompt();
    return this.prepareForRegisterAllSections().then((regAttributeApiParam) =>
      this.triggerSectionRegistration(this.getEligibleScheduledSectionIds(), [], regAttributeApiParam)
    );
  }

  private prepareForRegisterAllSections() {
    const allSectionIds = this.getEligibleScheduledSectionIds();
    return this.storeRegistrationAttributeValuesCommand()
      .then(() => this.selectAllRegistrationSectionsCommand())
      .then(() => this.waitForRegistraionAttributesToRenderCommand())
      .then(() => this.submitAndGetRegAttributesForm(allSectionIds));
  }

  private getEligibleScheduledSectionIds() {
    return this.ngRegisterSectionsQuery.result.scheduledSections
      .filter((section) => _4.get(section, '_isEligibleForRegistration', true))
      .map((section) => section.id);
  }

  saveTermPinAndContinue() {
    const selectedSectionIds = this.getSelectedSectionIds();
    this.submitAndGetRegAttributesForm(selectedSectionIds).then((regAttributeApiParam) =>
      this.saveTermPinCommand(this.$stateParams.termId).then(() => this.completeRegistration(regAttributeApiParam))
    );
  }

  onRegisterPortalTriggerEnded() {
    const registrationUrl = this.registrationRTRSvc.init(this.ngRegisterSectionsQuery.result.scheduledSections);
    this.$window.open(registrationUrl, '_blank');
  }
}

angular.module('capability-ng-scheduler').service('ngRegistrationFacade', RegistrationFacade);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/facades/registration_facade.ts